import * as React from 'react';
import Project from 'src/entities/Project';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import DueDiligenceComponent, {
  DueDiligenceRequestComponentProps
} from 'src/modules/project/partials/due-diligence/DueDiligence.component';
import { OpenModal, openModal } from 'src/actions/modal';
import DueDiligenceRequestContainer from 'src/modules/modals/due-diligence-request/DueDiligenceRequest.container';
import Person from 'src/entities/Person';
import {
  downloadDocument,
  DownloadDocumentAction
} from 'src/actions/project/download-document/DownloadDocument.actions';
import Investment from 'src/entities/Investment';

interface DispatchProps {
  download: (document: string, id: number, download: boolean) => Promise<DownloadDocumentAction>;

  openModal(component: JSX.Element): void;
}

interface StateProps {
  investment?: Investment;
}

interface Props extends StateProps, DispatchProps {
  project: Project;
  activeProfile: Person;
}

interface State {
  visibleDueDiligence: boolean;
  requested: boolean;
  toDownload: boolean;
  notAllowed: boolean;
}

class DueDiligenceContainer extends React.Component<Props, State> {

  public state = {
    visibleDueDiligence: false,
    requested: false,
    toDownload: false,
    notAllowed: false
  };

  public componentWillMount(): void {
    if (this.props.investment) {
      if (this.props.project.dueDiligenceStatus === 'Sí') {
        if (
          this.props.investment.dueDiligenceStatus !== 'Requested' &&
          this.props.investment.dueDiligenceStatus !== 'NDA Signed'
        ) {
          this.setState({
            notAllowed: true
          });
        } else if (
          this.props.investment.dueDiligenceStatus === 'NDA Signed' &&
          this.props.project.dueDiligenceReport
        ) {
          this.setState({
            toDownload: true
          });
        } else {
          this.setState({
            requested: true
          });
        }
      } else {
        if (
          this.props.investment.dueDiligenceStatus === 'Requested' ||
          this.props.investment.dueDiligenceStatus === 'NDA Signed'
        ) {
          this.setState({
            requested: true
          });
        }
      }
    } else {
      this.setState({
        notAllowed: true
      });
    }
  }

  public render(): React.ReactNode {
    return (
      <DueDiligenceComponent {...this.getComponentProps()} />
    );
  }

  private getComponentProps(): DueDiligenceRequestComponentProps {
    return {
      project: this.props.project,
      investment: this.props.investment,
      enableDueDiligence: () => this.enableDueDiligence(),
      visibleDueDiligence: this.state.visibleDueDiligence,
      requested: this.state.requested,
      toDownload: this.state.toDownload,
      notAllowed: this.state.notAllowed,
      requestDueDiligence: () => this.requestDueDiligence(),
      download: this.props.project.dueDiligenceReport ?
        () => this.props.download(this.props.project.dueDiligenceReport!, 1, false) : undefined,
    };
  }

  private enableDueDiligence() {
    this.setState({visibleDueDiligence: true});
  }

  private requestDueDiligence() {
    if (!this.state.visibleDueDiligence) {
      this.setState({visibleDueDiligence: true});
      return;
    }
    this.props.openModal(
      <DueDiligenceRequestContainer
        project={this.props.project}
        activeProfile={this.props.activeProfile}
      />
    );
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element): OpenModal => {
    return dispatch(openModal(component));
  },
  download: (document: string, id: number, download: boolean): Promise<DownloadDocumentAction> => {
    return dispatch(downloadDocument(document, id, download));
  }
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  investment: state.getInvestment.investment
});

export default connect(mapStateToProps, mapDispatchToProps)(DueDiligenceContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/due-diligence/DueDiligence.container.tsx